import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { CreateOrUpdateBudget } from 'domain/usecases/surgical-pendency/create-or-update-budget'

export class RemoteCreateOrUpdateBudget implements CreateOrUpdateBudget {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  add(params: CreateOrUpdateBudget.Params) {
    return this.surgicalOrderRepository.createOrUpdateBudget(params)
  }
}
